import {
    CO_GET_PRODUCTCATEGORY_LISTING,
    CO_GET_PRODUCTCATEGORY_LISTING_SUCCESS,
    CO_GET_PRODUCTCATEGORY_LISTING_FAILED,
  } from "./actionTypes"
  
  const initialState = {
    error: "",
    loading: false,
    productCategory: null,
  }
  
  const coProductCategory = (state = initialState, action) => {
    switch (action.type) {
      case CO_GET_PRODUCTCATEGORY_LISTING:
        state = {
          ...state,
          loading: true,
          productCategory: action.payload,
        }
        break
      case CO_GET_PRODUCTCATEGORY_LISTING_SUCCESS:
        state = { ...state, loading: false, productCategory: action.payload }
        break
      case CO_GET_PRODUCTCATEGORY_LISTING_FAILED:
        state = { ...state, loading: false }
        break
      default:
        state = { ...state }
        break
    }
    return state
  }
  
  export default coProductCategory
  